import { globalAxios,wellnessAxios } from "@/axios-path.js";
export default {
    namespaced: true,
    state: {
        reportList: [],
        storeList: []
    },
    mutations: {
        resetReportList(state) {
            state.reportList = [];
            
        },
        getReport(state, data) {
            state.reportList = data;
            console.log(state.reportList)
        },
        getAllStores(state, data) {
            state.storeList = data;
            state.storeList.unshift({
                store_id: 0,
                store_name_cn: null,
                store_name_en: "All",
                store_name_th: "ทั้งหมด",
            });
        },
    },
    actions: {
        getReport({ commit }, payload) {
            const data = payload;
            return globalAxios.get("/api/v1/WeserveXArtisgo/bof/get_report",
                {
                    params:
                    {
                        datetime_start: data.datetime_start,
                        datetime_end: data.datetime_end,
                        report_type: data.report_type,
                        order_type: data.order_type,
                        order_status: data.order_status,
                        store_id: data.store_id,
                        key_word: data.key_word
                    }
                }).then((res) => {
            if (res.msg == true) {
                commit('getReport', res.data);
                return
            } else {
                return res;
            }
            });
        },
        resetReportList({ commit }) {
            commit('resetReportList');
        },
        getAllStores({ commit }) {
            //   let endpoint = `?datetime_start=${data.datetime_start}&datetime_end=${data.datetime_end}&report_type=${data.report_type}&order_type=${data.order_type}&order_status=${data.order_status}&store_id=${data.store_id}&key_word=${data.key_word}`;
          return  wellnessAxios
                .get("/weservexartisgo/get_store_weserve")
              .then((res) => {
                    console.log(res.data);
                if (res.msg == true) {
                    commit('getAllStores', res.data);
                    return res.data;
                } else {
                    return [];
                }
            });
        }
  },
    getters: {
        getStoreList: state => state.storeList,
        getReportList: state => state.reportList,
    },
};
